import React, {useState} from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import { Tooltip } from 'react-tooltip';
import EmptyTableRow from "../../../../pages/common/EmptyTableRow";
import {ModalInnerConfirmType} from "../interface";
import {useModal} from "../../../../hooks";
import {
    ProductInListElementType,
    ProductInListMapType,
    ProductInSearchParamType
} from "../../../../pages/product/internal/list/interface";
import {productInListElementInit, productInSearchParamInit} from "../../../../pages/product/internal/list/state";
import {useReadProductIn} from "../../../../pages/product/internal/list/hooks/useReadProductIn";
import {useReadProductDetailIn} from "../../../../pages/product/internal/detail/hooks/useReadProductDetailIn";
import {ProductInDetailMapType} from "../../../../pages/product/internal/detail/interface";
import PaginationSub from "../../pagination/PaginationSub";

/**
 * 주소 검색 모달
 * @param props
 * @returns
 */
const SearchProductInner = ({
                                confirmCallback,
                                cancelCallback,
                                modalDepth
                            }: ModalInnerConfirmType<ProductInDetailMapType>) => {
    const {handleModal, resetModal} = useModal();

    const [searchOption, setSearchOption] =
        useState<ProductInSearchParamType>(productInSearchParamInit);

    const [selectItem, setSelectItem] = useState<ProductInListElementType>(productInListElementInit);

    const {data} = useReadProductIn({param: searchOption});
    const {data: productDetail} = useReadProductDetailIn({
        param: {
            ...searchOption,
            newErpProductid: selectItem.newErpProductid,
            enabled: selectItem.newErpProductid !== ""
        }
    })

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<ProductInSearchParamType> = (submitData) => {
        setSearchOption(submitData);
    };

    const onClose = () => {
        resetModal(modalDepth)
    }

    const onConfirm = () => {
        if (selectItem.newErpProductid !== "") {
            confirmCallback(productDetail);
            onClose()
        } else {
            handleModal({
                isOpen: true,
                contents: "제품을 선택해주세요.",
                type: "alert",
                depth: modalDepth + 1
            })
        }
    }

    const onCancel = () => {
        onClose()
        cancelCallback && cancelCallback()
    }

    return (
        <>
            <form className="d-flex mb-15px" onSubmit={handleSubmit(onSubmit)}>
                <select className="form-select w-120px" {...register("keywordType")}>
                    <option value={"1"}>전체</option>
                    <option value={"2"}>벤더</option>
                    <option value={"3"}>카테고리</option>
                    <option value={"4"}>품목</option>
                    <option value={"5"}>규격</option>
                    <option value={"6"}>중분류</option>
                    <option value={"7"}>대분류</option>
                    <option value={"8"}>제품군</option>
                </select>
                <input
                    type="text"
                    className="form-control w-250px ms-5px h-34px"
                    {...register("keyword")}
                />
                <button type="submit" className="btn btn-info btn_search w-80px ms-5px">
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                        alt=""
                    />
                    조회
                </button>
            </form>

            <table className="table table-bordered my_table table_modal" style={{ tableLayout: "fixed", width: "100%" }}>
                <thead>
                <tr>
                    <th style={{ width: "55px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}></th>
                    <th style={{ width: "100px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>벤더</th>
                    <th style={{ width: "100px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>카테고리</th>
                    <th style={{ width: "150px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>제품군</th>
                    <th style={{ width: "620px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>품목</th>
                    <th style={{ width: "330px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>규격</th>
                    {/*<th style={{ width: "130px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>대분류</th>*/}
                    {/*<th style={{ width: "130px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>중분류</th>*/}
                </tr>
                </thead>
                <tbody>
                {(data as ProductInListMapType)?.productList?.length === 0 ? (
                    <EmptyTableRow/>
                ) : (
                    (data as ProductInListMapType)?.productList?.map((el) => {
                        return (
                            <tr className={`clickable ${el.newErpProductid === selectItem?.newErpProductid ? "lightblue" : ""}`}
                                onClick={() => setSelectItem(el)}>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            checked={selectItem.newErpProductid === el.newErpProductid}
                                            onClick={() => setSelectItem(el)}
                                        />
                                    </div>
                                </td>
                                <td className="text-center">{el.vendor}</td>
                                <td className="text-center">{el.category}</td>
                                <td className="text-center">{el.productRange}</td>
                                <td
                                    className="text-center"
                                    data-tooltip-id="tooltip-item-name"
                                    data-tooltip-content={el.new_txt_nm_item}
                                    style={{
                                        width: "200px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {el.new_txt_nm_item}
                                </td>

                                <td
                                    className="text-center"
                                    data-tooltip-id="tooltip-item-std"
                                    data-tooltip-content={el.new_txt_stnd_item}
                                    style={{
                                        width: "200px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {el.new_txt_stnd_item}
                                </td>
                                {/*<td className="text-center">{el.majorCategory}</td>*/}
                                {/*<td className="text-center">{el.subCategory}</td>*/}


                            </tr>
                        );
                    })
                )}
                </tbody>

                <Tooltip id="tooltip-item-name" className="custom-tooltip" />
                <Tooltip id="tooltip-item-std" className="custom-tooltip" />
            </table>

            <PaginationSub totalCount={(data as ProductInListMapType)?.totalCount ?? 0}
                           currentPage={searchOption.pageNo}
                           onChangeCallback={(i) => setSearchOption({...searchOption, pageNo: i})}/>

            <div className="mt-3 d-flex align-items-center justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary w-100px h-38px my-0"
                    onClick={onCancel}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="btn btn-dark w-100px h-38px my-0 ms-3"
                    onClick={onConfirm}
                >
                    선택
                </button>
            </div>
        </>
    );
};

export default SearchProductInner;
